import React from 'react';
import { BODY_TEXT_2, EMPTY_IMAGE, HEADING_TEXT_2 } from '../../../utilities/generatedClasses';

const RecommendationEmptyState = () => (
  <div className="recommendations-empty-data">
    <div style={{ width: '269px', height: '196px' }} className={EMPTY_IMAGE} />
    <label className={HEADING_TEXT_2} style={{ marginTop: '24px' }}>No Recommendations Added</label>
    <label className={BODY_TEXT_2}>Click On "+" button to add recommendations</label>
  </div>
);

export default RecommendationEmptyState;
